// Filet anti-crash global — plus jamais de page blanche.
// Toute erreur de rendu dans l'app affiche cet écran propre au lieu du vide.
import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Trace pour le diagnostic (visible dans la console navigateur)
    console.error('[ErrorBoundary] Crash de rendu :', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
        style={{ background: '#f8f9fa' }}
      >
        <img
          src="/icons/abracada-logo.svg"
          alt="Abracada"
          className="w-16 h-16 rounded-2xl mb-5"
        />
        <h1
          className="text-xl font-bold mb-2"
          style={{ color: '#1a2a4a', fontFamily: "'Plus Jakarta Sans', sans-serif" }}
        >
          Oups, un petit souci technique…
        </h1>
        <p className="text-sm text-gray-500 mb-6 max-w-sm">
          Ce n'est pas toi, c'est nous. Recharge la page — si ça persiste,
          reviens à l'accueil.
        </p>
        <div className="flex gap-3">
          <button
            onClick={() => window.location.reload()}
            className="px-5 py-2.5 rounded-xl text-white font-semibold shadow-md"
            style={{ background: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)' }}
          >
            Recharger la page
          </button>
          <button
            onClick={() => { window.location.href = '/'; }}
            className="px-5 py-2.5 rounded-xl font-semibold border border-gray-300 text-gray-700 bg-white"
          >
            Retour à l'accueil
          </button>
        </div>
      </div>
    );
  }
}
